import { useState, useEffect } from "react";
import LoginPage from "./components/LoginPage";
import ReviewerApp from "./components/ReviewerApp";
import SupervisorApp from "./components/SupervisorApp";
import { useToast, Toasts } from "./components/ui/Toast";
import ErrorBoundary from "./components/ui/ErrorBoundary";

export default function App() {
  const [user, setUser] = useState(null);
  const [stations, setStations] = useState([]);
  const [checking, setChecking] = useState(true);
  const { ts, show: toast } = useToast();

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      setChecking(false);
      return;
    }
    fetch("/api/auth/me", { headers: { Authorization: "Bearer " + token } })
      .then((r) => {
        if (!r.ok) throw new Error();
        return r.json();
      })
      .then((d) => {
        setUser(d.user);
        setStations(d.stations || []);
      })
      .catch(() => localStorage.removeItem("token"))
      .finally(() => setChecking(false));
  }, []);

  const handleLogin = (u, s) => {
    setUser(u);
    setStations(s);
  };

  const handleLogout = async () => {
    try {
      await fetch("/api/auth/logout", {
        method: "POST",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "X-CSRF-Token": localStorage.getItem("csrf_token") || "",
        },
      });
    } catch {}
    localStorage.removeItem("token");
    localStorage.removeItem("csrf_token");
    setUser(null);
    setStations([]);
  };

  if (checking)
    return (
      <div
        style={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: "#020817",
          color: "#64748b",
          fontSize: 16,
        }}
      >
        ⏳ جاري التحميل...
      </div>
    );

  if (!user)
    return (
      <>
        <LoginPage onLogin={handleLogin} />
        <Toasts ts={ts} />
      </>
    );

  return (
    <>
      <ErrorBoundary>
        {user.role === "reviewer" ? (
          <ReviewerApp
            user={user}
            stations={stations}
            toast={toast}
            onLogout={handleLogout}
          />
        ) : (
          <SupervisorApp user={user} toast={toast} onLogout={handleLogout} />
        )}
      </ErrorBoundary>
      <Toasts ts={ts} />
    </>
  );
}
